module.exports = __webpack_public_path__ + "img/home_birthday.831337fa.jpg";